@if (showModal) {
<app-dialog-title>{{ "send-package" | transloco }}</app-dialog-title>
<mat-dialog-content class="content">
  @if (errorMessage) {
  <p class="error-message">{{ errorMessage }}</p>
  } @if (batchActionState !== 'COMPLETED' && !errorMessage) {
  <div>
    <p *transloco="let t">
      {{
        config.tenant === tenants.FR
          ? t(
              "are-you-sure-you-want-to-upload-the-package-to-kpmg-link-for-the-batch-and-selected-tax-return-alias-s"
            )
          : t(
              "are-you-sure-you-want-to-send-package-for-the-batch-and-selected-tax-return-alias-s"
            )
      }}
    </p>
  </div>
  } @if (batchActionState === 'COMPLETED') {
  <div>
    <p>
      {{
        "batch-send-package-process-has-been-started-this-may-take-a-while-we-will-update-you-on-the-progress"
          | transloco
      }}
    </p>
    <p>
      {{ 'if-you-update-the-tax-return-alias-again-you-will-need-to-generate-the-draft-or-final-package-for-the-batch-again-so-that-the-documents-get-updated-with-the-latest-changes' | transloco: {taxReturnAlias} }}
    </p>
  </div>
  }
</mat-dialog-content>
@if (batchActionState !== 'COMPLETED') {
<mat-dialog-actions align="end">
  <a class="go-back cancel" (click)="onClose()">{{ "cancel" | transloco }}</a>
  <button
    class="ui primary button"
    (click)="batchGenerate()"
    [disabled]="submitButtonDisabled"
    [ngClass]="{ loading: batchActionState === 'LOADING' }"
  >
    {{ "send-package" | transloco }}
  </button>
</mat-dialog-actions>
} @if (batchActionState === 'COMPLETED') {
<mat-dialog-actions align="end">
  <button class="ui primary button" (click)="onClose(true)">
    {{ "ok" | transloco }}
  </button>
</mat-dialog-actions>
} }
